import React from "react";
import cx from "classnames";
import { ErrorOutline } from "@mui/icons-material";

const MappingGroupNotice = ({ requiredFields }) => {
  if (!requiredFields) return null;

  return (
    <div className="mapping__group__cell">
      <div className="mapping__group__notice">
        <ErrorOutline className="mapping__group__notice__icon" />
        <span className="mapping__group__notice__message">
          <span className="t--500">Required Fields must be mapped.</span> {requiredFields}
        </span>
      </div>
    </div>
  );
};

export default MappingGroupNotice;
